/**
 * <s-topup> — one-tap credit top-up.
 * Each pack is a direct checkout link. The custom amount field builds its own checkout link and price as the viewer types.
 * <s-topup-return> (in the layout) remembers where the viewer was when they tap a checkout link.
 * Attributes: data-rate (cents per credit), data-cart-url, data-custom-variant, data-currency, data-locale,
 * data-balance (current credits), data-order (latest order id).
 */
class STopup extends HTMLElement {
  connectedCallback() {
    this.rate = Number(this.dataset.rate) || 0;
    this.format = new Intl.NumberFormat(this.dataset.locale || undefined, {
      style: 'currency',
      currency: this.dataset.currency || 'USD',
    });
    this.addEventListener('input', (event) => {
      if (event.target.matches('[data-custom-qty]')) this.#updateCustom(event.target);
    });
  }

  // Cart permalink (/cart/<variant>:<qty>) opens checkout with only the credits, where the store's ABA payment is offered.
  #updateCustom(input) {
    const link = this.querySelector('[data-custom-link]');
    const total = this.querySelector('[data-custom-total]');
    const variantId = this.dataset.customVariant;
    const credits = Math.floor(Number(input.value) || 0);
    if (!link || !variantId) return;
    if (credits < 1) {
      link.hidden = true;
      return;
    }
    link.setAttribute('href', `${this.dataset.cartUrl}/${variantId}:${credits}${input.dataset.query || ''}`);
    if (total) total.textContent = this.format.format((credits * this.rate) / 100);
    link.hidden = false;
  }
}

if (!customElements.get('s-topup')) customElements.define('s-topup', STopup);
